export class AlfredClientConfig {
  public alfredApiUrl!: string;

  public biebApiUrl!: string;

  public production!: boolean;

  public autoFocus!: boolean;
}
